import React from "react";

const ActivityHiddenWarning = () => <div className="alert alert-warning" role="alert">
  <b>Warning: </b>
You are editing an order for an experience that has been hidden.
  It may not work properly in every case.
Please double check that any price changes are correct.
</div>

export default ActivityHiddenWarning;
